import { ANNOTATIONS_SPACE, ANNOTATIONS_SPACE_PRINT } from '../data/constants';

export function chartSpacing(options) {
  const spacing = [16, 0, 0, 0];// formerly 28 for index 2
  if (options.type === 'bar') {
    spacing[0] += options.print ? -28 : -40;// This makes no sense to me.
    if (options.print) {
      spacing[2] = 0;
    }

    if (__WSJ__) {
      if (options.product === 'wsj') {
        if (options.print) {
          spacing[0] = -12;
          spacing[2] = 4;
        } else {
          spacing[0] = -20;
          spacing[2] = 8;
        }
      }
    }
  } else {
    if (__MARKETWATCH__) {
      if (options.product === 'marketwatch') {
        const hasExtraLegendSpacingRight = (options.legend.layout === 'right' && options.legend.enabled) ? true : false;
        const isLineOrColumn = options.type === 'line' || options.type === 'column';
        const isThumb = (options.size === 'thumb-marketwatch-MA' || options.size === 'marketwatch-ZR' || options.size === 'marketwatch-ZT');
        const hasSuffix = options.axes.units.suffix;
        const hasPrefix = options.axes.units.prefix;
        if (isThumb) {
          return spacing;
        }
        if (isLineOrColumn && options.annotations !== null) {
          // if no annotations spacing[0] should equal 6
          spacing[0] = options.annotations.length === 0 ? 6 : 16;
        }
        if (isLineOrColumn && options.annotations === null) {
          spacing[0] = 6;
        }
        if (isLineOrColumn && !hasExtraLegendSpacingRight) {
          const givenSuffix = hasSuffix === " thousand" || hasSuffix === "%" || hasSuffix === " hundred" || hasSuffix === " billion" || hasSuffix === " trillion" || hasSuffix === " cents";
          if (hasSuffix) {
            if (hasSuffix === " thousand") {
              spacing[1] = 70;
            }
            if (hasSuffix === "%") {
              spacing[1] = 20;
            }
            if (hasSuffix === " hundred") {
              spacing[1] = 60;
            }
            if (hasSuffix === " billion") {
              spacing[1] = 45;
            }
            if (hasSuffix === " trillion") {
              spacing[1] = 50;
            }
            if (hasSuffix === " cents") {
              spacing[1] = 40;
            }
            if (!givenSuffix) {
              let suffixLength = hasSuffix.length;
              let thousand = " thousand";
              let thousandLength = thousand.length;
              let diff = suffixLength - thousandLength;
              if (suffixLength === thousandLength) {
                spacing[1] = 70;
              }
              if (suffixLength > thousandLength) {
              spacing[1] = 70 + (diff * 7);
              } else {
                spacing[1] = 70 + (diff * 5)
              }
            }
          } else {
            spacing[1] = 6;
          }
          if (hasPrefix && !options.axes.units.formatDecimals && !hasExtraLegendSpacingRight) {
            spacing[1] = spacing[1] + 5;
          }
        }
      }

    }
    if (__FINANCIALNEWS__) {
      if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
        spacing[1] = options.type === 'column' && options.axes.units.suffix === '%' ? 15 : 6;

      }
    }

    if (__WSJ__) {
      if (options.product === 'wsj') {
        spacing[0] = 15;
        spacing[2] = 9;

        if (options.print) {
          spacing[0] = 14;
          spacing[2] = 9;
        }

        if(options.id === '16u'){
          spacing[0] = 16;
          spacing[2] = 10;
        }

        if(options.id === '12u'){
          spacing[0] = 14;
          spacing[2] = 10;
        }

        if(options.id === '8u'){
          spacing[0] = 13;
          spacing[2] = 7;
        }

        if(options.id === '4u'){
          spacing[0] = 12;
          spacing[2] = 6;
        }

        if(options.annotations !==null && options.annotations.length !== 0){
          spacing[0] += -3;
        }
      }
    }

  }
  if (Array.isArray(options.spacing)) {
    spacing.forEach((n, i) => {
      spacing[i] += options.spacing[i] || 0;
    });
  }
  return spacing;
}

// DO NOT USE! Interferes with legend spacing!!!
export function chartMargin(options) {
  return [null, null, null, null];
  // const lineHeight = parseFloat(options.styles.normal.lineHeight);
  // const margin = [lineHeight, null, lineHeight * 2, null];
  // if (options.type === 'bar') {
  //   margin[0] += 4;
  //   margin[2] -= lineHeight;
  // }
  // return margin;
  // if (options.size.indexOf('thumb') === 0) {
  //   return margin;
  // }
  // margin[0] = 16;
  // margin[2] = 28;
  // if (options.quarterlyResults && options.series[0].data.length <= 9) {
  //   margin[2] += parseFloat(options.styles.normal.fontSize);
  // }
  // if (__WSJ__) {
  //   if (options.size === 'print-wsj') {
  //     if (options.type === 'bar') {
  //       margin[0] = 14;
  //       margin[2] = 0;
  //     } else {
  //       margin[0] = 12;
  //       margin[2] = 8;
  //     }
  //   }
  // }
  // return margin;
}

export function addSpaceForAnnotations(spacing, options) {
  if (possibleAnnotationsSpacing(options) && needsAnnotationSpace(options)) {
    spacing[1] += options.print ? ANNOTATIONS_SPACE_PRINT : ANNOTATIONS_SPACE;
    options.spaceAddedForAnnotations = true;
  }
  return spacing;
}

function possibleAnnotationsSpacing(options) {
  return !(
    options.product === 'marketwatch' ||
    options.type === 'pie' ||
    options.type === 'bar' ||
    (options.type === 'column' && options.stacking)
  );
}

function needsAnnotationSpace(options) {
  const endIndex = Math.floor((options.maxDataLength - 1) * 0.95);
  for (let i = 0; i < options.annotations.length; i++) {
    const a = options.annotations[i];
    const attach = a.attach.point.enabled ? a.attach.point : a.attach.category;
    const index = attach.index;
    if (index >= endIndex) {
      if (a.lineEnd === 'circle') {
        return true;
      }
      if (options.print && a.lineEnd === 'dot') {
        return true;
      }
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/chart/inner/spacing.js